module.exports = {
    firebase: {
        apiKey: 'AIzaSyAUohuUX-BTdTat82YMZ7JFWTPski310_c',
        authDomain: 'partnerapiprod.firebaseapp.com',
        databaseURL: 'https://partnerapiprod.firebaseio.com',
        storageBucket: 'partnerapiprod.appspot.com',
    },
    cloudFunctionsUrl: '',
    captcha: {
        //Can be get after registration at https://www.google.com/recaptcha/admin
        siteKey: '6LfyB00UAAAAAIgsVBXrijubyyZk614qs_rCt3A7',
    },
    apiUrl: 'https://api.halo.fitness/partnerapi/api',
    qaApiUrl: 'https://api-vtqa.halo.fitness/partnerapi/api',
    restURL: 'https://docs-partnerapi-v3.halo.fitness/#partner-api-v3-reference',
    oldAPIConsoleURL: 'https://apiconsole.halo.fitness/',
    storageURL: 'https://firebasestorage.googleapis.com/v0/b/partnerapiprod.appspot.com/o/Web%2FDocumentation%2FRealTimeCallback%20documentation_v3.pdf?alt=media&token=fe21002c-27d5-4f94-a034-77e52fd46f28',
    GA_ANALYTICS: 'UA-132570787-2',
    termsAndConditionsURL: 'https://halo.fitness/web/halo.html#/termsOfUse?developerMode=true',
}



// WEBPACK FOOTER //
// ./src/config/config.js